export default __webpack_public_path__ + "static/media/record.9cf3e475.svg";